import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { faqs } from '../data/mock';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';

const About = () => {
  const values = [
    { title: 'Transparency', description: 'We communicate clearly about what is possible, what is not, and why.' },
    { title: 'Measurable Impact', description: 'Every project has defined KPIs and outcomes that matter.' },
    { title: 'Ethical AI', description: 'We build responsible AI systems with human oversight and accountability.' },
    { title: 'Climate Responsibility', description: 'We are committed to using technology for positive environmental impact.' }
  ];

  return (
    <div style={{ paddingTop: '80px', background: 'var(--bg-primary)' }}>
      {/* Hero */}
      <section style={{
        padding: '100px 7.6923%',
        background: 'var(--bg-primary)',
        textAlign: 'center'
      }}>
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          <h1 className="display-huge" style={{ marginBottom: '24px' }}>
            About Futura Softwares
          </h1>
          <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
            We exist at the intersection of AI engineering and climate action—building technology that solves real-world problems and helps organizations meet their sustainability commitments.
          </p>
        </div>
      </section>

      {/* Story */}
      <section style={{ padding: '100px 7.6923%', background: 'var(--bg-secondary)' }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
          <h2 className="display-medium" style={{ marginBottom: '32px' }}>
            Why We Exist
          </h2>
          <div style={{ display: 'grid', gap: '24px' }}>
            <p className="body-large" style={{ color: 'var(--text-secondary)', lineHeight: '1.8' }}>
              Climate change is the defining challenge of our time, and achieving global targets like the Paris Agreement and Kigali Amendment requires both policy expertise and advanced technology.
            </p>
            <p className="body-large" style={{ color: 'var(--text-secondary)', lineHeight: '1.8' }}>
              Traditional consultancies bring deep domain knowledge but lack AI/ML engineering capabilities. Tech companies build impressive systems but don't understand climate policy or emissions reduction strategies.
            </p>
            <p className="body-large" style={{ color: 'var(--text-secondary)', lineHeight: '1.8' }}>
              Futura bridges this gap. Our team combines production-grade AI development with hands-on experience advising governments and corporations on climate action. We don't just model scenarios—we've helped implement the policies. We don't just build agents—we've deployed them at scale.
            </p>
          </div>
        </div>
      </section>

      {/* Team section removed - can be added back later */}

      {/* Values */}
      <section style={{ padding: '100px 7.6923%', background: 'var(--bg-secondary)' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h2 className="display-medium" style={{ marginBottom: '60px', textAlign: 'center' }}>
            Our Values
          </h2>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '40px'
          }}>
            {values.map((value, idx) => (
              <div key={idx}>
                <h3 className="heading-2" style={{ marginBottom: '12px', color: 'var(--brand-primary)' }}>
                  {value.title}
                </h3>
                <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section style={{ padding: '100px 7.6923%', background: 'var(--bg-primary)' }}>
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          <h2 className="display-medium" style={{ marginBottom: '60px', textAlign: 'center' }}>
            Frequently Asked Questions
          </h2>
          <Accordion type="single" collapsible>
            {faqs.map((faq, idx) => (
              <AccordionItem key={idx} value={`item-${idx}`}>
                <AccordionTrigger className="heading-3">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="body-medium">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>

      {/* CTA */}
      <section style={{ padding: '100px 7.6923%', background: 'var(--bg-secondary)', textAlign: 'center' }}>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          <h2 className="display-large" style={{ marginBottom: '24px' }}>
            Let's work together
          </h2>
          <p className="body-large" style={{ marginBottom: '40px', color: 'var(--text-secondary)' }}>
            Whether you need AI tools or climate strategy, we're here to help.
          </p>
          <Link to="/contact" className="btn-primary">
            Get in touch
            <ArrowRight size={20} />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default About;
